import React, { useRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

const PeImage = ({ src, keepRatio, classes, placeHolder, alt }) => {
    const [loaded, setLoaded] = useState(false);
    const ImgElm = useRef(null);
    const width = width || '100%';
    const height = height || '100%';

    const ImgLoader = new Image();
    const handleScroll = () => {
        const ratioWH = ImgLoader.width / ImgLoader.height;
        if (!loaded && src) {
            // Load real image
            // ImgLoader.setAttribute(`src`, `${src}`);
            ImgElm.current.setAttribute(`src`, `${src}`);
            keepRatio &&
                ImgElm.current.setAttribute(`height`, `${width / ratioWH}`);
            setLoaded(true);
        }
    };

    useEffect(() => {
        ImgLoader.setAttribute(`src`, `${src}`);
        // cleanup toggles value, if unmounted
        return () => {
            ImgLoader.setAttribute(`src`, `${placeHolder}`);
        };
    }); // adjust dependencies to your needs

    return (
        <img
            src={placeHolder}
            width={width}
            height={height}
            onLoad={handleScroll}
            ref={ImgElm}
            className={classes.lazyImage}
            alt={alt}
        />
    );
};

export default PeImage;
